import { Modal } from '@carbon/react';

interface NoReconcileCandidatesModalProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Tells the user every candidate was eliminated by scoring: nothing to reconcile.
 * @param {NoReconcileCandidatesModalProps} props - Whether the modal is open, and its close handler
 * @return {JSX.Element} The modal
 */
export function NoReconcileCandidatesModal({
  open,
  onClose,
}: NoReconcileCandidatesModalProps) {
  return (
    <Modal
      open={open}
      modalHeading="No candidates to reconcile"
      primaryButtonText="OK"
      onRequestClose={onClose}
      onRequestSubmit={onClose}
    >
      <p>No candidates met the review threshold. No action was taken.</p>
    </Modal>
  );
}
